<script>
import options from './AdvancedRadio.options'
export default options
</script>

<template>
  <section class="Form__Element FormChoice">
    <p class="kb-fundraise-form__header">
      {{ legend }}
      <template v-if="tooltipText">
        <TooltipComponent :tooltipText="tooltipText" />
      </template>
    </p>

    <div class="kb-fundraise-form__donation-amount-wrapper">
      <div class="kb-fundraise-form__donation-input">
        <template v-for="(option, index) in radioOptions" :key="index">
          <input
            type="radio"
            :name="fieldName"
            :id="option.value"
            data-f-datainput=""
            :value="option.value"
            autocomplete="off"
            v-model="localValue"
            @change="formLink"
          />
          <label :for="option.value">
            {{ option.label }}
          </label>
        </template>
      </div>
    </div>

    <div aria-live="assertive">
      <p class="Form__Element__ValidationError"
          role="alert"
          v-if="inputHasValidationErrors && isValidationError"
        >
        {{ errorMessageLabel }}
      </p>
    </div>

    <p
      class="kb-form__input-helptext kb-form__input-helptext--radio"
      v-if="helpMessageLabel"
    >
      {{ helpMessageLabel }}
    </p>
    
  </section>
</template>
